import type { RouteLocation } from "vue-router";
import { useViewModelInstance } from "./MyGarageViewModelStore";
import { useUserSettings } from "@services/UserSettings";
import dayjs from "dayjs";
import { useAuth } from "@library/Security";
import { useUser } from "@domain/Security";
import { FeatureStatus } from "@domain/General/Enums/FeatureStatus";

/**
 * Controls the display of interrupt pages before allowing the user to access MyGarage
 * @param to 
 * @param from 
 * @returns 
 */
export const MyGarageRouteGuard = async ( to: RouteLocation, from: RouteLocation ) =>
{
    // User is a dealer mode user and not authorized access MyGarage
    const user = useUser();
    if( user.isDealerMode )
    {
        return '/dealer-mode'
    }

    const viewModel = await useViewModelInstance( true );
    if( viewModel == null ) return;

    // User needs to acknowledge their Carbucks Protect
    if( viewModel.carePlan.carbucksProtect.status == FeatureStatus.Pending )
    {
        return '/my-garage/acknowledge-carbucks-protect'
    }

    // User needs to connect their health monitor
    if( viewModel.showConnectToHealthMonitorWorkflow )
    {
        return '/my-garage/connect-health-monitor'
    }

    // User needs to update their odometer
    if( viewModel.vehicle.isOdometerUpdateRequired )
    {
        // Check if the user has skipped it, if not redirect them to the set odometer page
        const settings = useUserSettings();
        if( settings.skipUpdateOdometerReminderUntil == null || dayjs( settings.skipUpdateOdometerReminderUntil ).isBefore( dayjs() ) )
        {
            return '/my-garage/set-odometer'
        }
    }
};